/** 2xx – Success */
export type SuccessStatusCode = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207 | 208 | 226;

/** 4xx – Client Error */
export type ClientErrorStatusCode =
  | 400
  | 401
  | 402
  | 403
  | 404
  | 405
  | 406
  | 407
  | 408
  | 409
  | 410
  | 411
  | 412
  | 413
  | 414
  | 415
  | 416
  | 417
  | 418
  | 421
  | 422
  | 423
  | 424
  | 425
  | 426
  | 428
  | 429
  | 431
  | 451;

/** 5xx – Server Error */
export type ServerErrorStatusCode = 500 | 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 509 | 510 | 511;

/**
 * Return true if 400 <= code <= 499
 * @param statusCode number
 */
export function isStatusCodeClientError(statusCode: number): statusCode is ClientErrorStatusCode {
  return statusCode >= 400 && statusCode <= 499;
}

/**
 * Return true if 200 <= code <= 299
 * @param statusCode
 */
export function isStatusCodeSuccess(statusCode: number): statusCode is SuccessStatusCode {
  return statusCode >= 200 && statusCode <= 299;
}

/**
 * Return true if 500 <= code <= 599
 * @param statusCode
 */
export function isStatusCodeServerError(statusCode: number): statusCode is ServerErrorStatusCode {
  return statusCode >= 500 && statusCode <= 599;
}
